import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import {
  Globe,
  ShieldCheck,
  Search,
  Smartphone,
  TrendingUp,
  Sparkles,
} from 'lucide-react';
import { revealUp } from '../lib/anim';
import { WHY_2026 } from '../data/portfolio';

const ICONS = { Globe, ShieldCheck, Search, Smartphone, TrendingUp, Sparkles };

function Reason({ item, i }) {
  const Icon = ICONS[item.icon] || Sparkles;
  return (
    <motion.div
      variants={revealUp}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.3 }}
      custom={i}
      data-testid={`why-card-${item.n}`}
      className="group relative flex flex-col justify-between overflow-hidden rounded-[3px] border border-border bg-white/[0.015] p-8 transition-colors duration-500 hover:bg-white/[0.04] md:p-10"
    >
      <div className="pointer-events-none absolute -right-6 -top-6 font-display text-[7rem] font-extrabold leading-none tracking-tighter text-white/[0.03] transition-transform duration-700 group-hover:-translate-y-1">
        {item.n}
      </div>
      <div className="relative flex h-12 w-12 items-center justify-center rounded-full border border-border text-foreground transition-colors duration-500 group-hover:bg-foreground group-hover:text-background">
        <Icon className="h-5 w-5" strokeWidth={1.6} />
      </div>
      <div className="relative mt-10">
        <h3 className="font-display text-2xl font-medium leading-tight tracking-tight text-foreground">
          {item.title}
        </h3>
        <p className="mt-4 text-[15px] leading-relaxed text-muted-foreground">
          {item.body}
        </p>
      </div>
    </motion.div>
  );
}

export default function Why() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });
  const y = useTransform(scrollYProgress, [0, 1], ['8%', '-8%']);

  return (
    <section
      id="why"
      ref={ref}
      data-testid="why-section"
      className="mx-auto max-w-[1600px] px-6 py-24 md:px-12 md:py-32"
    >
      <div className="mb-16 grid grid-cols-1 gap-8 md:grid-cols-12 md:items-end">
        <div className="md:col-span-8">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">
            (Perché un sito nel 2026)
          </span>
          <motion.h2
            style={{ y }}
            className="mt-6 font-display text-4xl font-extrabold leading-[0.92] tracking-tighter text-foreground md:text-6xl"
          >
            Il tuo sito è la prima
            <br />
            impressione. E l&apos;unica
            <br />
            che conta davvero.
          </motion.h2>
        </div>
        <p className="text-base leading-relaxed text-muted-foreground md:col-span-4">
          Nel 2026 non basta esistere online: serve un&apos;esperienza che
          costruisca fiducia in pochi secondi. Ecco perché investire in un sito
          fatto bene cambia le regole del gioco.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {WHY_2026.map((item, i) => (
          <Reason key={item.n} item={item} i={i} />
        ))}
      </div>
    </section>
  );
}
